<form [formGroup]="kycForm" (ngSubmit)="submitHandler()">
  <app-loading [busy]="loading" [busyText]="'Loading data...'"></app-loading>

  <ng-container *ngIf="!loading">
    <div class="text-center">
      <div class="m-2">
        <button mdbBtn color="trakly-action" class="relative waves-light btn-sm btn" (click)="pullClientDetails()">Pull</button>
        <span *ngIf="dataExists" class="d-block small mt-2"> Last synced on: {{ lastSyncDate | date: "dd MMM yyyy 'at:' HH:mm" }} </span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!dataExists && !loading">
    <div class="md-form">
      <div class="card alert alert-warning mb-4 text-center">
        <div class="card-body">{{ noDataMessage }}</div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="dataExists && !loading">
    <div class="md-form">
      <div class="card mb-4">
        <div class="card-header">Personal Information</div>
        <div class="card-body my-auto" formGroupName="Personal">
          <div class="row col-12 d-flex mb-4">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtTitle" formControlName="Title" type="text" class="form-control" readonly />
              <label for="txtTitle">Title</label>
            </div>
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtFirstName" formControlName="FirstName" type="text" class="form-control" readonly />
              <label for="txtFirstName">First name</label>
            </div>
            <div class="col-4">
              <input mdbInput mdbValidate id="txtMiddleNames" formControlName="MiddleNames" type="text" class="form-control" readonly />
              <label for="txtMiddleNames">Middle names</label>
            </div>
          </div>

          <div class="row col-12 d-flex mb-4">
            <div class="col-4">
              <input mdbInput mdbValidate id="txtLastName" formControlName="LastName" type="text" class="form-control" readonly />
              <label for="txtLastName">Last name</label>
            </div>
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtFullName" formControlName="FullName" type="text" class="form-control" readonly />
              <label for="txtFullName">Full name</label>
            </div>
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtGender" formControlName="Gender" type="text" class="form-control" readonly />
              <label for="txtGender">Gender</label>
            </div>
          </div>

          <div class="row col-12 d-flex mb-4">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtEmail" formControlName="Email" type="email" class="form-control" readonly />
              <label for="txtEmail">Email</label>
              <div class="text-danger small mt-1" *ngIf="kycForm.get('Personal.Email')?.invalid && kycForm.get('Personal.Email')?.touched">
                Please provide a valid email
              </div>
            </div>
            <div class="col-4">
              <input mdbInput mdbValidate id="txtPhone" formControlName="PhoneNumber" type="text" class="form-control" readonly />
              <label for="txtPhone">Phone number</label>
            </div>
          </div>

          <div class="p-4"></div>

          <div class="row col-12 d-flex mb-4">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtDOB" formControlName="DateOfBirth" type="date" class="form-control" readonly />
              <label for="txtDOB" class="active">Date of Birth</label>
            </div>
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtID" formControlName="IdNumber" type="text" class="form-control" readonly />
              <label for="txtID">Id Number</label>
            </div>
            <div class="col-4">
              <input mdbInput mdbValidate id="txtTax" formControlName="TaxNumber" type="text" class="form-control" readonly />
              <label for="txtTax">Tax number</label>
            </div>
          </div>

          <div class="p-4"></div>

          <div class="row col-12 d-flex mb-4">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtCOB" formControlName="CountryOfBirth" type="text" class="form-control" readonly />
              <label for="txtCOB">Country of Birth</label>
            </div>
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtTOB" formControlName="TownOfBirth" type="text" class="form-control" readonly />
              <label for="txtTOB">Town of Birth</label>
            </div>
            <div class="col-4">
              <input mdbInput mdbValidate id="txtNationality" formControlName="Nationality" type="text" class="form-control" readonly />
              <label for="txtNationality">Nationality</label>
            </div>
          </div>

          <div class="row col-12 d-flex mb-4">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtCIF" formControlName="CIF" type="text" class="form-control" readonly />
              <label for="txtCIF">CIF Number</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md-form">
      <div class="card mb-4">
        <div class="card-header">Address</div>
        <div class="card-body my-auto" formGroupName="Address">
          <div class="row col-12 d-flex mb-4">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtAddressLine1" formControlName="AddressLine1" type="text" class="form-control" readonly />
              <label for="txtAddressLine1">Line 1</label>
            </div>
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtAddressLine2" formControlName="AddressLine2" type="text" class="form-control" readonly />
              <label for="txtAddressLine2">Line 2</label>
            </div>
            <div class="col-4">
              <input mdbInput mdbValidate id="txtCity" formControlName="AddressCity" type="text" class="form-control" readonly />
              <label for="txtCity">City</label>
            </div>
          </div>

          <div class="row col-12 d-flex">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtPostalCode" formControlName="AddressAreaCode" type="text" class="form-control" readonly />
              <label for="txtPostalCode">Postal Code</label>
            </div>
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtProvince" formControlName="AddressProvince" type="text" class="form-control" readonly />
              <label for="txtProvince">Province</label>
            </div>
            <div class="col-4">
              <input mdbInput mdbValidate id="txtCountry" formControlName="AddressCountry" type="text" class="form-control" readonly />
              <label for="txtCountry">Country</label>
            </div>
          </div>

          <hr class="hr m-5" />

          <div class="row col-12 d-flex mb-4">
            <div class="col-2"></div>
            <div class="col-8">
              <textarea
                mdbInput
                mdbValidate
                id="txtAddress"
                formControlName="Address"
                rows="2"
                class="md-textarea md-textarea-auto form-control"
                readonly
              ></textarea>
              <label for="txtAddress" class="active">Address (raw)</label>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="md-form">
      <div class="card mb-4">
        <div class="card-header">Employment</div>
        <div class="card-body my-auto" formGroupName="Employment">
          <div class="row col-12 d-flex mb-4">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtOccupation" formControlName="Occupation" type="text" class="form-control" readonly />
              <label for="txtOccupation">Occupation</label>
            </div>
            <div class="col-4 pr-5">
              <input
                mdbInput
                mdbValidate
                id="txtEmploymentDesignation"
                formControlName="EmploymentDesignation"
                type="text"
                class="form-control"
                readonly
              />
              <label for="txtEmploymentDesignation">Employment Designation</label>
            </div>
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtEmployer" formControlName="Employer" type="text" class="form-control" readonly />
              <label for="txtEmployer">Employer</label>
            </div>
          </div>

          <hr class="hr m-5" />

          <div class="row col-12 d-flex mb-4">
            <div class="col-2"></div>
            <div class="col-8">
              <textarea
                mdbInput
                mdbValidate
                id="txtEmploymentDescription"
                formControlName="EmploymentDescription"
                rows="2"
                class="md-textarea md-textarea-auto form-control"
                readonly
              ></textarea>
              <label for="txtEmploymentDescription" class="active">Employment Description</label>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="md-form">
      <div class="card mb-4">
        <div class="card-header">Income</div>
        <div class="card-body my-auto" formGroupName="Income">
          <div class="row col-12 d-flex">
            <div class="col-4 pr-5">
              <div class="form-check">
                <input id="chkIncomeR100k" type="checkbox" class="form-check-input" formControlName="IncomeR100k" disabled />
                <label class="form-check-label" for="chkIncomeR100k">Up to R100k</label>
              </div>
            </div>
            <div class="col-4 pr-5">
              <div class="form-check">
                <input id="chkIncomeR250k" type="checkbox" class="form-check-input" formControlName="IncomeR250k" disabled />
                <label class="form-check-label" for="chkIncomeR250k">Up to R250k</label>
              </div>
            </div>
            <div class="col-4 pr-5">
              <div class="form-check">
                <input id="chkIncomeR500k" type="checkbox" class="form-check-input" formControlName="IncomeR500k" disabled />
                <label class="form-check-label" for="chkIncomeR500k">Up to R500k</label>
              </div>
            </div>
          </div>

          <div class="row col-12 d-flex mt-3 mb-4">
            <div class="col-4 pr-5">
              <div class="form-check">
                <input id="chkIncomeR1milLess" type="checkbox" class="form-check-input" formControlName="IncomeR1milLess" disabled />
                <label class="form-check-label" for="chkIncomeR1milLess">Up to R1m</label>
              </div>
            </div>
            <div class="col-4 pr-5">
              <div class="form-check">
                <input id="chkIncomeR1milMore" type="checkbox" class="form-check-input" formControlName="IncomeR1milMore" disabled />
                <label class="form-check-label" for="chkIncomeR1milMore">More than R1m</label>
              </div>
            </div>
          </div>

          <div
            class="text-danger small mt-3"
            *ngIf="kycForm.get('Income')?.touched && kycForm.get('Income')?.errors?.['incomeMustBeSelected']"
          >
            Please select <strong>one</strong> income bracket.
          </div>
        </div>
      </div>
    </div>

    <div class="md-form">
      <div class="card mb-4">
        <div class="card-header">Source of Funds</div>
        <div class="card-body my-auto" formGroupName="SourceOfFunds">
          <div class="row col-12 d-flex">
            <div class="col-3 pr-5">
              <div class="form-check">
                <input id="chkSOFTrust" type="checkbox" class="form-check-input" formControlName="SOFTrust" disabled />
                <label class="form-check-label" for="chkSOFTrust">Trust</label>
              </div>
            </div>
            <div class="col-3 pr-5">
              <div class="form-check">
                <input id="chkSOFIncome" type="checkbox" class="form-check-input" formControlName="SOFIncome" disabled />
                <label class="form-check-label" for="chkSOFIncome">Income</label>
              </div>
            </div>
            <div class="col-3 pr-5">
              <div class="form-check">
                <input id="chkSOFProperty" type="checkbox" class="form-check-input" formControlName="SOFProperty" disabled />
                <label class="form-check-label" for="chkSOFProperty">Property</label>
              </div>
            </div>
            <div class="col-3 pr-5">
              <div class="form-check">
                <input id="chkSOFShares" type="checkbox" class="form-check-input" formControlName="SOFShares" disabled />
                <label class="form-check-label" for="chkSOFShares">Shares</label>
              </div>
            </div>

            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFInvestment" type="checkbox" class="form-check-input" formControlName="SOFInvestment" disabled />
                <label class="form-check-label" for="chkSOFInvestment">Investment</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFInvestments" type="checkbox" class="form-check-input" formControlName="SOFInvestments" disabled />
                <label class="form-check-label" for="chkSOFInvestments">Investments (Other)</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFCompany" type="checkbox" class="form-check-input" formControlName="SOFCompany" disabled />
                <label class="form-check-label" for="chkSOFCompany">Company</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFFamily" type="checkbox" class="form-check-input" formControlName="SOFFamily" disabled />
                <label class="form-check-label" for="chkSOFFamily">Family</label>
              </div>
            </div>

            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFBusiness" type="checkbox" class="form-check-input" formControlName="SOFBusiness" disabled />
                <label class="form-check-label" for="chkSOFBusiness">Business</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFSports" type="checkbox" class="form-check-input" formControlName="SOFSports" disabled />
                <label class="form-check-label" for="chkSOFSports">Sports</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFInheritance" type="checkbox" class="form-check-input" formControlName="SOFInheritance" disabled />
                <label class="form-check-label" for="chkSOFInheritance">Inheritance</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFLoan" type="checkbox" class="form-check-input" formControlName="SOFLoan" disabled />
                <label class="form-check-label" for="chkSOFLoan">Loan</label>
              </div>
            </div>

            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFGifts" type="checkbox" class="form-check-input" formControlName="SOFGifts" disabled />
                <label class="form-check-label" for="chkSOFGifts">Gifts</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFLottery" type="checkbox" class="form-check-input" formControlName="SOFLottery" disabled />
                <label class="form-check-label" for="chkSOFLottery">Lottery</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFCasino" type="checkbox" class="form-check-input" formControlName="SOFCasino" disabled />
                <label class="form-check-label" for="chkSOFCasino">Casino</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFSavings" type="checkbox" class="form-check-input" formControlName="SOFSavings" disabled />
                <label class="form-check-label" for="chkSOFSavings">Savings</label>
              </div>
            </div>

            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFDivorce" type="checkbox" class="form-check-input" formControlName="SOFDivorce" disabled />
                <label class="form-check-label" for="chkSOFDivorce">Divorce Settlement</label>
              </div>
            </div>
            <div class="col-3 pr-5 mt-3">
              <div class="form-check">
                <input id="chkSOFOther" type="checkbox" class="form-check-input" formControlName="SOFOther" disabled />
                <label class="form-check-label" for="chkSOFOther">Other</label>
              </div>
            </div>

            <div class="col-5 pr-5 mt-3">
              <input
                mdbInput
                mdbValidate
                id="txtSOFDescription"
                formControlName="SOFDescription"
                type="text"
                class="form-control"
                readonly
              />
              <label for="txtSOFDescription" class="active">Source of Funds Description (if other)</label>
            </div>
          </div>
          <div class="row col-12 d-flex mb-4 mt-5">
            <div class="col-4 pr-5">
              <input mdbInput mdbValidate id="txtSOF" formControlName="SOF" type="text" class="form-control" readonly />
              <label for="txtSOF">Primary Source of Funds</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</form>

<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
